import { get, writable } from 'svelte/store';
import { CustomListService } from '../../services/custom-list.service';
export const loading = writable(false);
export const editing = writable(false);
export const selectedSchema = writable(0);
export const records = writable([]);
export const record = writable(null);
let initialized = false;
export async function init() {
    if (!initialized) {
        initialized = true;
        editing.set(false);
        selectedSchema.set(0);
        records.set([]);
        record.set(null);
    }
}
export async function loadSchemaValues(schemaId) {
    let data = await CustomListService.getCustomListValues(schemaId).toPromise();
    records.set(data.payload);
}
export async function reloadSchemaValues() {
    let schemaId = get(selectedSchema);
    loadSchemaValues(schemaId);
}
export function onCreate() {
    let item = {
        oid: 0,
        description: '',
        displayOrder: 1,
        schemaId: get(selectedSchema),
        regionId: 0
    };
    record.set(item);
    editing.set(true);
}
export function onEdit(item) {
    record.set(Object.assign({}, item));
    editing.set(true);
}
export async function save() {
    let _record = get(record);
    _record.schemaId = get(selectedSchema);
    await CustomListService.saveCustomListValue(_record).toPromise();
    await reloadSchemaValues();
}
export async function onDelete(item) {
    await CustomListService.deleteCustomListValue(item.oid).toPromise();
    await reloadSchemaValues();
}
